import { FixedComponentsRateChartRequestColumns, FgPriceListRequest, FixedComponentsRateChartRequest, FixedComponentsRateChartResponseModel } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { FixedComponentsRateChart } from "./fixed-components-rate-chart-entity";
import { FixedComponentsRateChartLogs } from "./fixed-components-log-entity";

@Injectable()

export class FixedComponentsRateChartService{
    constructor(
        @InjectRepository(FixedComponentsRateChart) private repo: Repository<FixedComponentsRateChart>,
        @InjectRepository(FixedComponentsRateChartLogs) private logrepo: Repository<FixedComponentsRateChartLogs>

    ){}
  
    async getAllFixedComponentsRateChartInfo(): Promise<FixedComponentsRateChartResponseModel> {
        try {
            let res = []
            const info = await this.repo.find()
            if (info.length>0) {
                for(const data of info ){
                    res.push(new FixedComponentsRateChartRequest(data.id,data.component,data.price,data.createdUser,data.updatedUser,data.isActive,data.versionFlag,data.createdAt,data.category,data.packingCategory))
                }
                return new FixedComponentsRateChartResponseModel(true, 1,'Data retrieved',res)
            } else {
                return new FixedComponentsRateChartResponseModel(false, 0,'No data found')
            }
        } catch (err) {
            return new FixedComponentsRateChartResponseModel(false, 0, 'Something went wrong', err)
        }
    }
    async getDuplicateComponent(comp: string): Promise<FixedComponentsRateChart> {
        //  console.log(employeeId);
            const response = await this.repo.findOne({
            where: {component: comp},
            });
            // console.log(response);
            if (response) {
            return response;
            } else {
            return null;
            }
        }
        async createFixedComponentsRateChart(dto: FixedComponentsRateChartRequest, isUpdate: boolean): Promise<FixedComponentsRateChartResponseModel> {
            try {
                let res=[]
                if (!isUpdate) {
                    const existing = await this.repo.findOne({ where: { component: dto.component } });
                    if (existing) {
                        throw new Error('Component already exists');
                    }
                }
                const entityData = new FixedComponentsRateChart();
                entityData.component = dto.component
                entityData.price = dto.price
                entityData.isActive = dto.isActive
                entityData.category = dto.category
                entityData.packingCategory = dto.packingCategory
                if (isUpdate) {
                    const existingData = await this.repo.findOne(dto.id);

                    if (existingData) {
                        const log = new FixedComponentsRateChartLogs()
                        log.RefId = new FixedComponentsRateChart()
                        log.RefId.id = existingData.id
                        log.effectiveFrom = existingData.createdAt
                        log.category = existingData.category
                        log.PackingCategory = existingData.packingCategory
                        // log.oldPrice = existingData.price
                       const existLog = await this.logrepo.findOne({where:{RefId : existingData.id}})
                       if(existLog){
                        await this.logrepo.update({id:existLog.id},{oldPrice:existingData.price,category:existingData.category,PackingCategory:existingData.packingCategory})
                       }else{
                        log.oldPrice = existingData.price
                        await this.logrepo.save(log);
                       }
                    }
        
                    entityData.updatedUser = dto.updatedUser
                    entityData.id = dto.id

                } else {
                    entityData.createdUser = dto.createdUser;
                }
                const data = await this.repo.save(entityData);
                res.push(new FixedComponentsRateChartRequest(data.id,data.component,data.price,data.createdUser,data.updatedUser,data.isActive,data.versionFlag,data.createdAt,data.category,data.packingCategory))
                return new FixedComponentsRateChartResponseModel(true, 1, isUpdate ? 'Data updated successfully' : 'Component created successfully', res);
            } catch (err) {
                throw err;
            }
        }
   
}